export default __webpack_public_path__ + "static/Asset4@2x-91dde4720990e65fb44664b786bdfd91.png";